// colors.js
const colors = {
  dark: "#2c2f36", // Dark gray almost black
  gray: "#809699", // Lighter gray with a hint of blue
  yellow: "#fcc963", // yellowish
  brown: "#8f4a1d", // warm brown
  teal: "#49978d", // greenish tealish
  lightBlue: "#afc4c3", //lighter gray with hint of blue almost a light blue
  mustard: "#dc983d", // darker yellowish
  ice: "#e9eef6", //cool grayish white
  putty: "#d5c29c", // putty color
  pink: "#cb9c8d", // weird pinkish
  lavender: "#ccc2c8", // lavender
  // Add more colors as needed
};

export default colors;
